import { right } from '@popperjs/core';
import React from 'react';

const Checkbox = ({ value, setValue, label, validationValue, defaultChecked, callback, labelWidth, usedInExl, disabled }) => {

    const handleCheckBoxChange = (e) => {
        setValue(e.target.checked);
        if (callback) {
            callback(e.target.checked, validationValue)
        }
    }

    if (value === '')
        setValue(defaultChecked);

    return (
        <div className='btn p-2 w-100 h-100' >
            <label id={usedInExl ? 'exl-checkbox' : 'fte-checkbox'} className='checkbox-item d-flex p-auto w-100 mb-0'>
                <div className='pr-3'>
                    <input
                        type='checkbox'
                        value={value}
                        checked={value}
                        onClick={(e) => handleCheckBoxChange(e)}
                        disabled={disabled}
                        readOnly={true}
                        defaultChecked={defaultChecked}
                    />
                    <span className='flexible-checkmark my-auto' />
                </div>
                <div className='d-flex pl-4 my-auto'>
                    <div style={{ width: labelWidth }}>{label}</div>
                </div>
            </label>
        </div>
    );
};

export default Checkbox;
